import AxiosInstance from "./axiosInstance"

const pick = (dealer, ...keys) => {
  for (const key of keys) {
    const value = dealer?.[key]
    if (
      value != null &&
      value !== "" &&
      String(value).toLowerCase() !== "null"
    ) {
      return value
    }
  }
  return null
}

/** Normalizes API dealer payloads (PascalCase or camelCase) for Recoil state. */
export function normalizeDealerFromApi(dealer) {
  if (!dealer || typeof dealer !== "object") return dealer

  const rooftopID = pick(
    dealer,
    "rooftopID",
    "roofTopID",
    "RooftopID",
    "rooftop_id"
  )

  return {
    ...dealer,
    dealerID: pick(dealer, "dealerID", "DealerID", "dealerid"),
    businessName: pick(dealer, "businessName", "BusinessName"),
    zipCode: pick(dealer, "zipCode", "ZipCode"),
    primaryMake: pick(dealer, "primaryMake", "PrimaryMake"),
    rooftopID,
    random_id: pick(dealer, "random_id", "randomID", "Random_id"),
  }
}

export function getDealerRooftopId(dealer) {
  return pick(dealer, "rooftopID", "roofTopID", "RooftopID", "rooftop_id")
}

/** Persists dealer id for BigQuery axios interceptor. */
export function persistBigQueryDealerId(dealer) {
  const normalized = normalizeDealerFromApi(dealer)
  if (!normalized || normalized.dealerID == null) {
    sessionStorage.removeItem("domgBigQueryDealerId")
    return
  }
  sessionStorage.setItem("domgBigQueryDealerId", String(normalized.dealerID))
}

export async function getApiHelper(url, params = null) {
  try {
    const response = await AxiosInstance.get(url, params)
    return response
  } catch (error) {
    return error
  }
}

export async function postApiHelper(url, body = null, config = null) {
  try {
    const response = await AxiosInstance.post(url, body, config)
    return response
  } catch (error) {
    return error
  }
}

export async function putApiHelper(url, body = null, config = null) {
  try {
    const response = await AxiosInstance.put(url, body, config)
    return response
  } catch (error) {
    return error
  }
}

export async function patchApiHelper(url, body = null, config = null) {
  try {
    const response = await AxiosInstance.patch(url, body, config)
    return response
  } catch (error) {
    return error
  }
}

export async function deleteApiHelper(url, body = null) {
  try {
    const response = await AxiosInstance.delete(url, { data: body })
    return response
  } catch (error) {
    return error
  }
}
